import type { RouteObject } from "react-router-dom";

export const shippingClaimRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Carrier claims" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page hidePadding={() => true} /> };
    },
    children: [
      {
        index: true,
        async lazy() {
          const { AdminShippingClaimsPage } =
            await import("./admin-shipping-claims-page");
          return { Component: AdminShippingClaimsPage };
        },
      },
    ],
  },
];
